import {Pipe, PipeTransform} from '@angular/core';
import {ScheduledChecklistDto} from '../../../Models/Tasks/Checklists/Schedules/scheduled-checklist.interface';

@Pipe({
  name: 'schedulesChecklist',
  standalone: false
})
export class SchedulesChecklistPipe implements PipeTransform {

  transform(items: ScheduledChecklistDto[], filter: {
    isAudit: boolean,
    local?: number,
    department?: number,
    category?: number,
    period?: number,
  }): ScheduledChecklistDto[] {

    if (!items || items.length === 0) {
      return [];
    }

    items = items.filter((item) => item.auditoria === (filter.isAudit ? 1 : 0));

    if (filter.local) {
      items = items.filter((item) => item.id_local === filter.local);
    }

    if (filter.department) {
      items = items.filter((item) => item.id_departamento == filter.department);
    }

    if (filter.category) {
      items = items.filter((item) => item.id_partida === filter.category);
    }

    if (filter.period) {
      items = items.filter((item) => item.id_periodo === filter.period);
    }

    return items;

  }

}
